import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { GameEditorData } from "components/views/editor/gameEditor/models/GameEditorData";
import { isValidEventKey } from "constants/eventValidation";

export const useGameEditorValidator = () => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const isValid = (data: GameEditorData | undefined): boolean => {
        if (!data) return false;

        if (!data.fileId || data.fileId.trim() === "") {
            enqueueSnackbar(t("gameEditor.validation.fileRequired"), {
                anchorOrigin: { vertical: "bottom", horizontal: "center" },
                variant: "error",
            });
            return false;
        }

        const invalidEvent = data.events.find(
            (e) => e.event.trim() !== "" && !isValidEventKey(e.event)
        );
        if (invalidEvent) {
            enqueueSnackbar(t("gameEditor.validation.eventFormat"), {
                anchorOrigin: { vertical: "bottom", horizontal: "center" },
                variant: "error",
            });
            return false;
        }

        return true;
    };

    return { isValid };
};
